import { journeyAction, } from './base';

import { JourneyActionClient as JourneyActionClientBase, } from 'atlas-shared';

export const JourneyActionClient = journeyAction({
  ...JourneyActionClientBase,
  icon: 'Client',
});
